import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import { CSSTransition } from 'react-transition-group'

import { localize } from 'helpers/translator'
import FirstLessonIntro from './first_lesson_intro/first_lesson_intro'
import FirstLessonUpload from './first_lesson_upload/first_lesson_upload'
import FirstLessonLoading from './first_lesson_loading/first_lesson_loading'

import styles from './first_lesson_overlay.scss'

class FirstLessonOverlay extends PureComponent {

	constructor() {
		super()
		this.state = {
			step: 'intro',
		}
	}

	introCompleted = () => {
		this.setState({
			step: 'upload',
		})
	}

	firstLessonFilePicked = file => {
		this.props.firstLessonFilePicked(file)
		this.setState({
			step: 'loading',
		})
	}

	shouldShowHeader = () => this.state.step === 'intro' || this.state.step === 'upload'

	render() {

		return (
			<div styleName='wrapper'>
				<header styleName='header'>
					<h1 styleName='logo'></h1>
				</header>
				<section styleName='main-content'>
					<CSSTransition
						in
						appear
						classNames={{
							appear: styles.appear,
							appearActive: styles['appear-active'],
						}}
						timeout={1700}
					>
						<div styleName='content'>
							{ this.shouldShowHeader() &&
								<div styleName='content-header'>
									<h1 styleName='title'>{localize('first_lesson_overlay_title')}</h1>
									<h2 styleName='subtitle'>{localize('first_lesson_overlay_subtitle')}</h2>
								</div>
							}
							<div styleName='content-body'>
								{ this.state.step === 'intro' &&
									<FirstLessonIntro
										introCompleted={this.introCompleted}
									/>
								}
								{ this.state.step === 'upload' &&
									<FirstLessonUpload
										firstLessonFilePicked={this.firstLessonFilePicked}
										firstLessonFilePickedError={this.props.firstLessonFilePickedError}
										firstLessonClosed={this.props.firstLessonClosed}
									/>
								}
								{ this.state.step === 'loading' &&
									<FirstLessonLoading
										animationCompleted={this.props.firstLessonAnimationLoadingCompleted}
									/>
								}
							</div>
						</div>
					</CSSTransition>
				</section>
			</div>
		)
	}
}

FirstLessonOverlay.propTypes = {
	firstLessonFilePicked: PropTypes.func,
	firstLessonFilePickedError: PropTypes.func,
	firstLessonClosed: PropTypes.func,
	firstLessonAnimationLoadingCompleted: PropTypes.func,
}

FirstLessonOverlay.defaultProps = {
	firstLessonFilePicked: () => {},
	firstLessonFilePickedError: () => {},
	firstLessonClosed: () => {},
	firstLessonAnimationLoadingCompleted: () => {},
}

export default CSSModules(FirstLessonOverlay, styles, {allowMultiple: true})
